/*
 * @Author: zhushitao
 * @Date: 2021-07-21 15:14:17
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-19 20:54:09
 * @Description:
 */

import { Region } from './lang';

export enum ENV {
  PROD = 'PROD',
  PPE = 'ppe',
  BOE = 'boe',
  LOCAL = 'local',
  TEST = 'TEST',
  Tob = 'tob',
}

export const apiOrigin = {
  PROD: 'https://ngcc.bytedance.com',
  PPE: 'https://ngcc.bytedance.com',
} as Record<string, string>;

export const imCloudConfig = {
  [Region.cn]: {
    PROD: {
      appId: 1402,
      fpId: 89,
      appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
      apiUrl: 'https://imapi-oth.zijieapi.com/',
      frontierUrl: 'wss://im-ws.zijieapi.com/ws/v2',
      service: 2,
      uploadRegion: 'cn-north-1',
      videoDomain: 'https://vod.bytedanceapi.com',
      imageDomain: 'https://imagex.bytedanceapi.com',
    },
    PPE: {
      appId: 1402,
      fpId: 89,
      appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
      apiUrl: 'https://imapi-oth.zijieapi.com/',
      frontierUrl: 'wss://im-ws.zijieapi.com/ws/v2',
      service: 2,
      uploadRegion: 'cn-north-1',
      videoDomain: 'https://vod.bytedanceapi.com',
      imageDomain: 'https://imagex.bytedanceapi.com',
    },
  },
  [Region.sg]: {
    PROD: {
      appId: 4946,
      fpId: 89,
      method: 1,
      appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
      apiUrl: 'https://imapi2.isnssdk.com',
      frontierUrl: 'wss://frontier.byteoversea.com/ws/v2',
      service: 2,
      uploadRegion: 'ap-singapore-1',
      videoDomain: 'https://vod-ap-singapore-1.bytevcloudapi.com',
      imageDomain: 'https://imagex-ap-singapore-1.bytevcloudapi.com',
    },
    PPE: {
      appId: 4946,
      fpId: 89,
      method: 1,
      appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
      apiUrl: 'https://imapi2.snssdk.com/',
      frontierUrl: 'wss://frontier.snssdk.com/ws/v2',
      service: 2,
      uploadRegion: 'ap-singapore-1',
      videoDomain: 'https://vod-ap-singapore-1.bytevcloudapi.com',
      imageDomain: 'https://imagex-ap-singapore-1.bytevcloudapi.com',
    },
  },
};

//Non-Chinese audio & video file configuration https://bytedance.feishu.cn/wiki/wikcnweNHZqiEMtFJNBtqY11w4c#
export const mediaDomain = {
  [ENV.BOE]: 'https://vas-boei18n.bytedance.net',
  [ENV.PROD]: 'https://vas-alisg16.byteoversea.com',
};
export const logDomain = {
  [ENV.BOE]: 'https://log.snssdk.com',
  [ENV.PROD]: 'https://log.isnssdk.com',
};
